import { useState, useEffect } from "react";
import { useGetAllGoalCategoriesQuery } from "src/services/GoalCategoryServices";

export const useGoalCategory = () => {
  const [goalCategory, setgoalCategory] = useState<any[]>([]);
  const [isDataLoading, setIsDataLoading] = useState(true);

  const { data, isLoading, isFetching } = useGetAllGoalCategoriesQuery("");

  useEffect(() => {
    if (isLoading || isFetching) {
      setIsDataLoading(true);
    } else {
      const result: any[] = data?.data;
      setgoalCategory(result || []);
      setIsDataLoading(false);
    }
  }, [data, isLoading, isFetching]);

  return { goalCategory, isDataLoading };
};
